import React, { useState, useEffect, useMemo } from 'react'
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TabsNav from "../common/ProcessNav";
import { Box, Button } from "@mui/material";
import MultipleInput from "../../../components/Card/MultipleInput";
import Table from "./Table"
import TablePhase from "./TablePhase"
import TableLevel from "./TableLevel"
import Pagination from '../../../components/Pagination/index';
import Loader from '../../../components/Loader/loader';
import SnackBar from '../../../components/Snackbars/CustomizedSnackbars';
import AddParamter from './AddParamter';
import AddPhase from './AddPhase';
import AddTable from './AddTable';
import DynamicFilter from '../../../components/Fillter/DyanamicFillter';
import { useDispatch, useSelector } from "react-redux";
import * as uop from "../../../redux/parameter/actions";
import * as para from "../../../redux/parameter/actions";
import ConfirmationDialog from '../../../components/DialogBox/Confirmation';
import debounce from "lodash.debounce";
import { formatLocal } from '../../../utility';
import ExcelView from './ExcelView';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const ParamterList = () => {


    const [page, setPage] = useState(1);
    const [filterOpen, setFilterOpen] = useState(false);
    const [openDailog, setOpenDailog] = useState(false);
    const [openExcelTemplate, setOpenExcelTemplate] = useState(false);
    const [openTableDailog, setOpenTableDailog] = useState(false);
    const [openRestoreDailog, setOpenRestoreDailog] = useState(false);
    const [openApproveDailog, setOpenApproveDailog] = useState(false);
    const [openPhaseDailog, setOpenPhaseDailog] = useState(false);
    const userName = localStorage.getItem('userName');
    const [tabValue, setTabValue] = useState(0);
    const [parameterData, setParameterData] = useState({
        parameter_id: '',
        created_by: userName,
        updated_by: userName
    });
    const [phaseData, setphaseData] = useState({
        phase_name: '',
        user: userName
    });
    const [tableData, setTableData] = useState({
        table_id: '',
        table_name: '',
        user: userName
    });
    const [snack, setSnack] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [openParameter, setOpenParameter] = useState(false);
    const [openPhase, setOpenPhase] = useState(false);
    const [openTable, setOpenTable] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [selectedUnitOpid, setSelectedUnitOpid] = useState();
    const rowsPerPage = 50;
    const [addErrors, setAddErrors] = useState();
    const dispatch = useDispatch();
    const process = useSelector((state) => state?.process);
    const [debouncedSearch, setDebouncedSearch] = useState();
    const [selectedOption, setSelectedOption] = useState('add_parameter');
    const [search, setSearch] = useState();
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
    });
    const filterConfig = [
        {
            key: "from_date",
            label: "Created Date",
            type: "dateRange",
            fromKey: "from_date",
            toKey: "to_date",
        },
    ]
    const multiOptions = [
        { label: "Add Parameter", value: "add_parameter" },
        { label: "Add Phase", value: "add_phase" },
        // { label: "QQ Chart", value: "qq_chart" },
        { label: "Add Table Level", value: "add_table" },
    ];


    const handleReset = () => {
        setFilters({
            from_date: "",
            to_date: "",
        });
    }

    const handlePageChange = (event, value) => {
        setPage(value);
        if (tabValue === 0) getParaListCall(value);
        if (tabValue === 1) getPhaseListCall(value);
        if (tabValue === 2) getTableListCall(value);
    };

    const handleChange = (field, value) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    };

    const debouncedSetValue = useMemo(
        () =>
            debounce((val) => {
                setDebouncedSearch(val);
            }, 700),
        []
    );

    const handleSearch = (e) => {
        setSearch(e.target.value);
        debouncedSetValue(e.target.value);
    };

    const validateAddErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!parameterData.parameter_name) newErrors.parameter_name = "Required";
        if (!parameterData.unit_op_id) newErrors.unit_op_id = "Required";
        if (!parameterData.source_system) newErrors.source_system = "Required";
        if (!parameterData.data_type) newErrors.data_type = "Required";
        // if (!parameterData.site_id) newErrors.site_id = "Required";
        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const validatePhaseErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!phaseData.phase_name) newErrors.phase_name = "Required";

        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const validateTableErrors = (isRequired) => {
        setAddErrors({});
        const newErrors = {};
        if (!tableData.table_name) newErrors.table_name = "Required";

        setAddErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        let newValue;
        if (typeof value === "string") {
            newValue = value?.trim() === "" ? null : value;
        } else {
            newValue = value === "" ? null : value;
        }

        if (selectedOption === 'add_phase') setphaseData((prev) => ({ ...prev, [name]: newValue }));
        if (selectedOption === 'add_table') setTableData((prev) => ({ ...prev, [name]: newValue }));
        if (selectedOption === 'add_parameter') setParameterData((prev) => ({ ...prev, [name]: newValue }));
    }

    const handleAddPhase = async (e) => {
        e.preventDefault();
        if (!validatePhaseErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(uop.UpdatePhase(phaseData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenPhase(false)
                dispatch(uop.getParaMeta())
                getPhaseListCall(1)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.message || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddPhase(phaseData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenPhase(false)
                dispatch(uop.getParaMeta())
                getPhaseListCall(1)
            } catch (error) {

                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleAddTable = async (e) => {
        e.preventDefault();
        if (!validateTableErrors(false)) return;
        if (selectedRow) {
            try {
                const res = await dispatch(uop.UpdateTableLevel(tableData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenTable(false)
                getTableListCall(1)
                dispatch(uop.getParaMeta())
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.message || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddTableLevel(tableData));
                setSnack({
                    open: true,
                    message: res.data.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenTable(false)
                getTableListCall(1);
                dispatch(uop.getParaMeta())
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        if (!validateAddErrors(false)) return;
        if (parameterData?.parameter_id) {
            try {
                const res = await dispatch(para.UpdatePara(parameterData));
                setSnack({
                    open: true,
                    message: res.data.message || "Updated successfully. Please review and approve.",
                    severity: "success"
                });
                setOpenParameter(false)
                getParaListCall(page)
            } catch (error) {
                setSnack({
                    open: true,
                    message: error.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        } else {
            try {
                const res = await dispatch(uop.AddParameter(parameterData));
                setSnack({
                    open: true,
                    message: res?.data?.message || "Added successfully. Please review and approve.",
                    severity: "success"
                });

                setOpenParameter(false)
                getParaListCall(page)

            } catch (error) {
                setSnack({
                    open: true,
                    message: error?.response?.data?.error || "Something went wrong",
                    severity: "error"
                });
            }
        }
    };

    const handleReorderColumn = async (data) => {
        try {
            const res = await dispatch(para.reOrderColumn(data));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            // setOpenParameter(false)
            // getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }

    };

    const handleReorderSheet = async (e) => {
        e.preventDefault();
        try {
            const res = await dispatch(para.reOrderSheet(parameterData));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            // setOpenParameter(false)
            // getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }

    };


    const handleDeletePhase = async () => {
        try {
            const res = await dispatch(uop.deletePhase(selectedRow));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            setOpenPhaseDailog(false)
            getPhaseListCall(page)
            dispatch(uop.getParaMeta())
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleDeleteTable = async () => {
        try {
            const res = await dispatch(uop.deleteTableLevel(selectedRow));
            setSnack({
                open: true,
                message: res.data.message || "Updated successfully. Please review and approve.",
                severity: "success"
            });
            setOpenTableDailog(false)
            getTableListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleRestoreTable = async () => {
        try {
            const res = await dispatch(uop.restoreParameter(selectedRow.param));
            setSnack({
                open: true,
                message: res.data.message || "Restored successfully",
                severity: "success"
            });
            setOpenTableDailog(false)
            getTableListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const handleApprovePara = async () => {
        try {
            const res = await dispatch(uop.approveParameter({
                unit_op_id: selectedRow.unit_op_id,
                approved_by: userName
            }));
            setSnack({
                open: true,
                message: res.data.message || "Approved successfully",
                severity: "success"
            });
            setOpenApproveDailog(false)
            getParaListCall(page)
        } catch (error) {
            setSnack({
                open: true,
                message: error.response?.data?.error || "Something went wrong",
                severity: "error"
            });
        }
    }

    const getParaListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(para.getParaList(data))
    }

    const getTableListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(uop.getTableList(data))
    }

    const getPhaseListCall = (page) => {
        const data = {
            page: page,
            page_size: rowsPerPage
        }
        if (search) data.search = debouncedSearch;
        if (filters.from_date) data.from_date = formatLocal(filters.from_date);
        if (filters.to_date) data.to_date = formatLocal(filters.to_date);
        dispatch(uop.getPhaseList(data))
    }


    // useEffect(() => {
    //     if (tabValue === 0) getParaListCall(page);
    //     if (tabValue === 1) getTableListCall(page);
    //     if (tabValue === 2) getPhaseListCall(page);
    // }, [page])

    const handleSetSelection = (option) => {
        setSelectedOption(option)
        if (option === 'add_phase') {
            setphaseData({
                phase_name: '',
                user: userName
            });
            setOpenPhase(true)
        };
        if (option === 'add_table') {
            setOpenTable(true);
            setTableData({
                table_id: '',
                table_name: '',
                user: userName
            })
        };
        if (option === 'add_parameter') {
            setOpenParameter(true);
            setParameterData({
                parameter_id: '',
                created_by: userName,
                updated_by: userName
            })
        };
    }

    useEffect(() => {
        setPage(1)
        if (tabValue === 0) getParaListCall(1);
        if (tabValue === 1) getPhaseListCall(1);
        if (tabValue === 2) getTableListCall(1);
    }, [tabValue, debouncedSearch])

    // useEffect(() => {
    //     setPage(1)
    //     if (tabValue === 0) getParaListCall(1);
    //     if (tabValue === 1) getPhaseListCall(1);
    //     if (tabValue === 2) getTableListCall(1);
    // }, [debouncedSearch])


    useEffect(() => {
        dispatch(uop.getParaMeta())
    }, [])


    const handleDelete = async () => {
        try {
            const res = await dispatch(para.DeletePara({ parameter_id: selectedRow.param.parameter_id, deleted_by: userName }));
            setSnack({
                open: true,
                message: res.data.message || "Deleted successfully",
                severity: "success"
            });
            setOpenDailog(false);
            getParaListCall(page)

        } catch (error) {
            setSnack({
                open: true,
                message: error.message || "Something went wrong",
                severity: "error"
            });
        }

    }

    const handleGenerate = () => {
        getParaListCall(1)
    }

    const handleAddUop = () => {
        setOpenParameter(true)
        parameterData({
            step_name: '',
            site_id: '',
            product_id: '',
            user: userName
        })
        setSelectedRow('')
    }

    const handleMenuOption = (option, row) => {
        setSelectedRow(row)
        if (option === 'delete') {
            setOpenDailog(true);
        } else if (option === 'restore') {
            setOpenRestoreDailog(true);
        } else {
            setParameterData({
                parameter_id: row.param.parameter_id,
                unit_op_id: row.row.unit_op_id,
                phase_name: row.param.phase,
                table_level_name: row.param.table_level,
                parameter_name: row.param.parameter_name,
                description: row.param.description,
                notes: row.param.notes,
                unit_of_measure: row.param.unit_of_measure,
                parameter_class: row.param.parameter_class,
                data_type: row.param.data_type,
                source_system: row.param.source_system,
                is_required: row.param.is_required,
                created_by: userName,
                updated_by: userName
            })
            setOpenParameter(true)
        }
    }

    const handlePhaseMenuOption = (option, row) => {
        setSelectedRow({ phase_id: row.id, user: userName })
        if (option === 'Delete') {
            setOpenPhaseDailog(true);
        }
    }
    const handleTableMenuOption = (option, row) => {
        setSelectedRow({ table_id: row.id, user: userName })
        if (option === 'Delete') {
            setOpenTableDailog(true);
        }
    }

    const handleTableLevel = (row) => {
        // console.log(row, 'table level')
    }

    const getTotalPerPage = () => {
        if (tabValue === 0) return process?.paraList?.data?.total / rowsPerPage
        if (tabValue === 1) return process?.phaseList?.data?.total / rowsPerPage
        if (tabValue === 2) return process?.tableList?.data?.total / rowsPerPage
    }

    const handleUnitOp = (row) => {
        setSelectedUnitOpid(row.unit_op_id)
        setOpenExcelTemplate(true)
    }

    const handleParaApprove = (row) => {
        setSelectedRow(row)
        setOpenApproveDailog(true)
    }

    return (
        <> <CAMHeader />
            <CAMDrawer />
            <InvestigatorContainer>  <TabsNav />
                {openExcelTemplate ?
                    <>
                        <Box sx={{ mt: 1, pt: 1, p: 1, borderTop: '1px solid #D5D7DA' }}>
                            <Button
                                startIcon={<ArrowBackIcon />}
                                sx={{
                                    textTransform: "none",
                                    borderRadius: "20px !important",
                                    paddingX: 2,
                                    paddingY: 0.2,
                                    backgroundColor: "#E9EAEB",
                                    color: "Black",
                                }}
                                onClick={() => setOpenExcelTemplate(false)}
                            >
                                Back
                            </Button></Box>
                        <ExcelView selectedUnitOpid={selectedUnitOpid} /></> :
                    <>
                        <Box sx={{ borderTop: "1px solid #e0e0e0" }}>
                            <MultipleInput
                                text={'Process List'}
                                // buttonText={"Add Unit Operation"}
                                popupFilter={true}
                                onButtonClick={handleAddUop}
                                setOption={handleSetSelection}
                                selectedOption={selectedOption}
                                placeholder='Search by name'
                                // handleChildClick={handleChildClick}
                                // handleClick={handleClick}
                                // handleMenuOptionCallBack={handleMenuOptionCallBack}
                                // filterOptionsGroup1={group1}
                                // filterOptionsGroup2={group2}
                                // selectedFilters={selectedFilters}
                                // handleCheckboxChange={handleCheckboxChange}
                                isMultiOptinButton={true}
                                // isAuditLogs={true}
                                handleSearch={handleSearch}
                                search={search}
                                showTab={true}
                                // viewAuditLogs={viewAuditLogs}
                                // auditText={"Audit Trail"}
                                // viewLogs={viewLogs}
                                // popupFilter={true}
                                handlePopupFilter={() => setFilterOpen(true)}
                                // onBackClick={() => setViewLogs(false)}
                                options={multiOptions}
                                tabValue={tabValue}
                                setTabValue={setTabValue}
                            />
                        </Box>
                        {snack?.open && (
                            <SnackBar
                                className="popup"
                                handleClose={() => {
                                    setSnack({
                                        open: false,
                                        message: "",
                                        severity: "",
                                    });
                                }}
                                severity={snack.severity}
                                state={snack?.open}
                                text={snack?.message}
                            />
                        )}
                        <Box>
                            <AddParamter
                                open={openParameter}
                                formData={parameterData}
                                onChange={handleOnChange}
                                onClose={() => setOpenParameter(false)}
                                errors={addErrors}
                                handleSubmit={handleAddSubmit}
                                dropdownOption={process}

                            />
                            <AddPhase
                                open={openPhase}
                                formData={phaseData}
                                onChange={handleOnChange}
                                onClose={() => setOpenPhase(false)}
                                errors={addErrors}
                                handleSubmit={handleAddPhase}
                                dropdownOption={process}

                            />
                            <AddTable
                                open={openTable}
                                formData={tableData}
                                onChange={handleOnChange}
                                onClose={() => setOpenTable(false)}
                                errors={addErrors}
                                handleSubmit={handleAddTable}
                                dropdownOption={process}

                            />
                        </Box>
                        <DynamicFilter
                            open={filterOpen}
                            onClose={() => setFilterOpen(false)}
                            filterValues={filters}
                            onReset={handleReset}
                            onGenerate={handleGenerate}
                            // data={auditLogs || []}
                            onChange={handleChange}
                            isStatusVisible={false}
                            filterConfig={filterConfig}
                        />



                        <Box width="100%" className="parameter-table">
                            <ConfirmationDialog
                                open={openDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this parameter?"
                                onConfirm={handleDelete}
                                onCancel={() => setOpenDailog(false)}
                                loading={process?.deleteProcess?.loading}
                            />
                            <ConfirmationDialog
                                open={openPhaseDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this Phase?"
                                onConfirm={handleDeletePhase}
                                onCancel={() => setOpenPhaseDailog(false)}
                                loading={process?.deletePhase?.loading}
                            />
                            <ConfirmationDialog
                                open={openTableDailog}
                                title="Confirm Deletion"
                                message="Do you really want to delete this Table?"
                                onConfirm={handleDeleteTable}
                                onCancel={() => setOpenTableDailog(false)}
                                loading={process?.deleteTable?.loading}

                            />
                            <ConfirmationDialog
                                open={openRestoreDailog}
                                title="Confirm Restoration"
                                message="Do you really want to restore this Parameter?"
                                onConfirm={handleRestoreTable}
                                onCancel={() => setOpenRestoreDailog(false)}
                                text='Restore'
                            />
                            <ConfirmationDialog
                                open={openApproveDailog}
                                title="Confirm Approval"
                                message="Are you sure you want to approve this parameter? Please confirm the Excel sheet and parameter order are verified."
                                onConfirm={handleApprovePara}
                                onCancel={() => setOpenApproveDailog(false)}
                                text='Approve'
                                loading={process?.approveParameter?.loading}
                            />
                            {tabValue === 0 && <Table data={process.paraList || []} onVisibilityClick={handleUnitOp} moreOption={["Update"]} handleMenuOption={handleMenuOption} handleTableLevel={handleTableLevel} handleReorderColumn={handleReorderColumn} handleApprove={handleParaApprove} />}
                            {tabValue === 1 && <TablePhase data={process.phaseList || []} moreOption={["Delete"]} handleMenuOption={handlePhaseMenuOption} handleTableLevel={handleTableLevel} />}
                            {tabValue === 2 && <TableLevel data={process.tableList || []} moreOption={["Delete"]} handleMenuOption={handleTableMenuOption} handleTableLevel={handleTableLevel} />}
                            {process?.paraList?.loading && <Loader />}
                            {process?.phaseList?.loading && <Loader />}
                            {process?.tableList?.loading && <Loader />}
                            <Pagination
                                count={getTotalPerPage()}
                                page={page}
                                onChange={handlePageChange}
                            />
                        </Box>
                    </>}
            </InvestigatorContainer>
        </>
    )
}

export default ParamterList